import { call, put, takeLatest } from "redux-saga/effects";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  ePlanLopTinChiActionIds,
  IPlanLopTinChiActionTypes,
} from "./../../action-types/lop-tin-chi/IPlanLopTinChiActions";

import { planLopTinChiApi } from "../../../api/lop-tin-chi/planLopTinChiApi";
import { rootActions } from "../../actions/rootActions";
import { IPlanLopTinChiSelectRequest } from "../../../model/request/lop-tin-chi/IPlanLopTinChiSelectRequest";

export function* planLopTinChiSaga(): any {
  yield takeLatest(ePlanLopTinChiActionIds.LOAD_START, selectWorker);
}

function* selectWorker(action: IPlanLopTinChiActionTypes): any {
  const res: IBaseRespone = yield call(
    planLopTinChiApi.Select,
    action.payload as IPlanLopTinChiSelectRequest
  );
  if (res.is_success) {
    yield put(rootActions.lopTinChi.planLopTinChi.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.lopTinChi.planLopTinChi.LOAD_ERRR(res.message ?? "Có lỗi")
    );
  }
}
